import { useNavigate } from '@lib/react-router-dom'

import { Account } from '@pages/Trade/types'

import { CommonPaths } from '@utils/path-common'

import { isLiveAccount } from '@model/TradingAccount'

import { useFundingNav } from '@hooks/useFundingNav'

export const useFundAccount = (account: Account, onAfterNavigate?: () => void) => {
  const navigate = useNavigate()
  const { navigateToFunding } = useFundingNav()

  const fundAccount = () => {
    if (!isLiveAccount(account.accountGroupType)) {
      navigate(`/dashboard/traders-room/trading-accounts/${account.id}/demo/add-balance`)
    } else {
      navigateToFunding(`${CommonPaths.TradersRoomTradingAccounts}/${account.id}/deposit`)
    }
    onAfterNavigate?.()
  }

  return fundAccount
}
